// International location hierarchy for geo-targeted SEO landing pages
// Structure: Continents -> Countries -> Cities
// UK country entry references existing cityData.js via useLegacyCities flag

const continents = [
  {
    slug: "europe",
    name: "Europe",
    description: "Professional dhol players available across Europe for weddings, corporate events, and cultural celebrations. Imperial Drummers brings authentic Punjabi dhol entertainment to venues throughout the continent.",
    metaTitle: "Dhol Players in Europe | Professional Dhol Drummers | Imperial Drummers",
    metaDescription: "Book professional dhol players across Europe. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in the UK, France, Germany, Italy, Spain & more.",
    countries: [
      {
        slug: "united-kingdom",
        name: "United Kingdom",
        useLegacyCities: true,
        description: "The UK's premier dhol entertainment company. Professional Punjabi dhol players for Asian weddings, Indian weddings, and cultural celebrations nationwide.",
        metaTitle: "Dhol Players UK | Professional Dhol Drummers United Kingdom | Imperial Drummers",
        metaDescription: "Book professional dhol players across the United Kingdom. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in London, Birmingham, Manchester & all major UK cities.",
        cities: []
      },
      {
        slug: "france",
        name: "France",
        description: "Professional dhol players available for destination weddings and celebrations across France. From Parisian luxury venues to the French Riviera, Imperial Drummers brings authentic Punjabi dhol entertainment to your French event.",
        metaTitle: "Dhol Players France | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in France for destination weddings & events. Imperial Drummers provides authentic Punjabi dhol entertainment in Paris, Nice, Lyon & across France.",
        majorCities: ["Marseille", "Toulouse", "Bordeaux", "Strasbourg", "Nantes", "Montpellier", "Lille", "Cannes", "Saint-Tropez"],
        cities: [
          {
            slug: "paris",
            name: "Paris",
            description: "Professional dhol players for weddings and events in Paris. From elegant Champs-Elysees venues to charming chateaux in the Ile-de-France region, our drummers bring authentic Punjabi energy to your Parisian celebration.",
            metaTitle: "Dhol Players Paris | Professional Dhol Drummers France | Imperial Drummers",
            metaDescription: "Book professional dhol players in Paris for Asian weddings & events. Imperial Drummers provides authentic Punjabi dhol entertainment at Parisian venues & chateaux across Ile-de-France."
          },
          {
            slug: "nice",
            name: "Nice",
            description: "Professional dhol players for destination weddings and events on the French Riviera. Our drummers bring vibrant Punjabi entertainment to luxury venues along the Cote d'Azur.",
            metaTitle: "Dhol Players Nice | Dhol Drummers French Riviera | Imperial Drummers",
            metaDescription: "Book professional dhol players in Nice for destination weddings on the French Riviera. Authentic Punjabi dhol entertainment for Asian weddings & events on the Cote d'Azur."
          },
          {
            slug: "lyon",
            name: "Lyon",
            description: "Professional dhol players for weddings and cultural events in Lyon. Our experienced drummers bring authentic Punjabi rhythms to celebrations across France's gastronomic capital.",
            metaTitle: "Dhol Players Lyon | Professional Dhol Drummers | Imperial Drummers",
            metaDescription: "Book professional dhol players in Lyon for Asian weddings & events. Imperial Drummers provides authentic Punjabi dhol entertainment across Lyon and the Rhone-Alpes region."
          }
        ]
      },
      {
        slug: "italy",
        name: "Italy",
        description: "Professional dhol players for destination weddings across Italy. From romantic Tuscan villas to Venetian palazzos, Imperial Drummers delivers authentic Punjabi dhol entertainment for your Italian celebration.",
        metaTitle: "Dhol Players Italy | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Italy for destination weddings & events. Authentic Punjabi dhol entertainment in Rome, Venice, Milan, Florence & across Italy.",
        majorCities: ["Naples", "Turin", "Bologna", "Palermo", "Genoa", "Verona", "Bari", "Catania", "Amalfi", "Lake Como", "Sorrento", "Siena", "Positano"],
        cities: [
          {
            slug: "rome",
            name: "Rome",
            description: "Professional dhol players for weddings and events in Rome. Our drummers bring authentic Punjabi energy to celebrations at stunning venues across the Eternal City.",
            metaTitle: "Dhol Players Rome | Professional Dhol Drummers Italy | Imperial Drummers",
            metaDescription: "Book professional dhol players in Rome for Asian weddings & events. Authentic Punjabi dhol entertainment at venues across Rome and the Lazio region."
          },
          {
            slug: "venice",
            name: "Venice",
            description: "Professional dhol players for destination weddings in Venice. From grand palazzos to waterfront celebrations, our drummers create unforgettable moments in the floating city.",
            metaTitle: "Dhol Players Venice | Dhol Drummers Italy | Imperial Drummers",
            metaDescription: "Book professional dhol players in Venice for destination weddings. Authentic Punjabi dhol entertainment for Asian weddings at Venetian palazzos and luxury venues."
          },
          {
            slug: "milan",
            name: "Milan",
            description: "Professional dhol players for weddings and events in Milan. Our experienced drummers bring vibrant Punjabi entertainment to celebrations in Italy's fashion capital.",
            metaTitle: "Dhol Players Milan | Professional Dhol Drummers | Imperial Drummers",
            metaDescription: "Book professional dhol players in Milan for Asian weddings & events. Imperial Drummers provides authentic Punjabi dhol entertainment across Milan and Lombardy."
          },
          {
            slug: "florence",
            name: "Florence",
            description: "Professional dhol players for destination weddings in Florence and Tuscany. Our drummers bring authentic Punjabi rhythms to celebrations at beautiful Tuscan villas and historic venues.",
            metaTitle: "Dhol Players Florence | Dhol Drummers Tuscany | Imperial Drummers",
            metaDescription: "Book professional dhol players in Florence for destination weddings in Tuscany. Authentic Punjabi dhol entertainment at Tuscan villas and Florentine venues."
          }
        ]
      },
      {
        slug: "germany",
        name: "Germany",
        description: "Professional dhol players for weddings and events across Germany. Imperial Drummers serves the South Asian communities in Berlin, Frankfurt, Munich and beyond with authentic Punjabi dhol entertainment.",
        metaTitle: "Dhol Players Germany | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Germany for Asian weddings & events. Authentic Punjabi dhol entertainment in Berlin, Frankfurt, Munich & across Germany.",
        majorCities: ["Hamburg", "Cologne", "Dusseldorf", "Stuttgart", "Dortmund", "Essen", "Leipzig", "Dresden", "Hanover", "Nuremberg", "Bremen"],
        cities: [
          {
            slug: "berlin",
            name: "Berlin",
            description: "Professional dhol players for weddings and events in Berlin. Our drummers bring authentic Punjabi energy to celebrations across Germany's vibrant capital city.",
            metaTitle: "Dhol Players Berlin | Professional Dhol Drummers Germany | Imperial Drummers",
            metaDescription: "Book professional dhol players in Berlin for Asian weddings & events. Authentic Punjabi dhol entertainment across Berlin and Brandenburg."
          },
          {
            slug: "frankfurt",
            name: "Frankfurt",
            description: "Professional dhol players for weddings and events in Frankfurt. Our experienced drummers provide authentic Punjabi entertainment for celebrations in the Rhein-Main metropolitan area.",
            metaTitle: "Dhol Players Frankfurt | Professional Dhol Drummers | Imperial Drummers",
            metaDescription: "Book professional dhol players in Frankfurt for Asian weddings & events. Authentic Punjabi dhol entertainment across Frankfurt and the Rhein-Main area."
          },
          {
            slug: "munich",
            name: "Munich",
            description: "Professional dhol players for weddings and events in Munich. Our drummers bring vibrant Punjabi rhythms to celebrations across Bavaria's capital and surrounding region.",
            metaTitle: "Dhol Players Munich | Dhol Drummers Bavaria | Imperial Drummers",
            metaDescription: "Book professional dhol players in Munich for Asian weddings & events. Authentic Punjabi dhol entertainment across Munich and Bavaria."
          }
        ]
      },
      {
        slug: "spain",
        name: "Spain",
        description: "Professional dhol players for destination weddings and events across Spain. From Barcelona to Marbella, Imperial Drummers brings authentic Punjabi dhol entertainment to your Spanish celebration.",
        metaTitle: "Dhol Players Spain | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Spain for destination weddings & events. Authentic Punjabi dhol entertainment in Barcelona, Madrid, Marbella & across Spain.",
        majorCities: ["Seville", "Valencia", "Malaga", "Ibiza", "Majorca", "Granada", "Bilbao", "Alicante", "Tenerife"],
        cities: [
          {
            slug: "barcelona",
            name: "Barcelona",
            description: "Professional dhol players for destination weddings and events in Barcelona. Our drummers bring authentic Punjabi entertainment to celebrations along the stunning Catalonian coast.",
            metaTitle: "Dhol Players Barcelona | Dhol Drummers Spain | Imperial Drummers",
            metaDescription: "Book professional dhol players in Barcelona for destination weddings & events. Authentic Punjabi dhol entertainment across Barcelona and Catalonia."
          },
          {
            slug: "madrid",
            name: "Madrid",
            description: "Professional dhol players for weddings and events in Madrid. Our experienced drummers provide vibrant Punjabi entertainment for celebrations in Spain's capital.",
            metaTitle: "Dhol Players Madrid | Professional Dhol Drummers Spain | Imperial Drummers",
            metaDescription: "Book professional dhol players in Madrid for Asian weddings & events. Authentic Punjabi dhol entertainment across Madrid and central Spain."
          },
          {
            slug: "marbella",
            name: "Marbella",
            description: "Professional dhol players for luxury destination weddings in Marbella. Our drummers bring authentic Punjabi energy to celebrations at exclusive Costa del Sol venues.",
            metaTitle: "Dhol Players Marbella | Dhol Drummers Costa del Sol | Imperial Drummers",
            metaDescription: "Book professional dhol players in Marbella for luxury destination weddings. Authentic Punjabi dhol entertainment on the Costa del Sol."
          }
        ]
      },
      {
        slug: "netherlands",
        name: "Netherlands",
        description: "Professional dhol players for weddings and events across the Netherlands. Imperial Drummers serves the South Asian communities in Amsterdam, The Hague, and beyond.",
        metaTitle: "Dhol Players Netherlands | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in the Netherlands for Asian weddings & events. Authentic Punjabi dhol entertainment in Amsterdam, The Hague & across Holland.",
        majorCities: ["Rotterdam", "The Hague", "Utrecht", "Eindhoven", "Groningen"],
        cities: [
          {
            slug: "amsterdam",
            name: "Amsterdam",
            description: "Professional dhol players for weddings and events in Amsterdam. Our drummers bring authentic Punjabi entertainment to celebrations across the Dutch capital.",
            metaTitle: "Dhol Players Amsterdam | Dhol Drummers Netherlands | Imperial Drummers",
            metaDescription: "Book professional dhol players in Amsterdam for Asian weddings & events. Authentic Punjabi dhol entertainment across Amsterdam and the Netherlands."
          }
        ]
      },
      {
        slug: "denmark",
        name: "Denmark",
        description: "Professional dhol players for weddings and events in Denmark. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Copenhagen and across Scandinavia.",
        metaTitle: "Dhol Players Denmark | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Denmark for Asian weddings & events. Authentic Punjabi dhol entertainment in Copenhagen and across Denmark.",
        majorCities: ["Aarhus", "Odense", "Aalborg"],
        cities: [
          {
            slug: "copenhagen",
            name: "Copenhagen",
            description: "Professional dhol players for weddings and events in Copenhagen. Our drummers bring vibrant Punjabi energy to celebrations in Denmark's cosmopolitan capital.",
            metaTitle: "Dhol Players Copenhagen | Dhol Drummers Denmark | Imperial Drummers",
            metaDescription: "Book professional dhol players in Copenhagen for Asian weddings & events. Authentic Punjabi dhol entertainment across Copenhagen and Denmark."
          }
        ]
      },
      {
        slug: "monaco",
        name: "Monaco",
        description: "Professional dhol players for luxury weddings and events in Monaco. Imperial Drummers delivers authentic Punjabi dhol entertainment for exclusive celebrations on the French Riviera.",
        metaTitle: "Dhol Players Monaco | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Monaco for luxury weddings & events. Authentic Punjabi dhol entertainment for exclusive celebrations in Monte Carlo.",
        majorCities: ["Monte Carlo", "La Condamine", "Fontvieille"],
        cities: []
      },
      {
        slug: "ireland",
        name: "Ireland",
        description: "Professional dhol players for weddings and events across Ireland. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Dublin, Belfast, and throughout the Emerald Isle.",
        metaTitle: "Dhol Players Ireland | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Ireland for Asian weddings & events. Authentic Punjabi dhol entertainment in Dublin, Belfast & across Ireland.",
        majorCities: ["Belfast", "Cork", "Galway", "Limerick", "Waterford"],
        cities: [
          {
            slug: "dublin",
            name: "Dublin",
            description: "Professional dhol players for weddings and events in Dublin. Our drummers bring authentic Punjabi energy to celebrations across Ireland's vibrant capital city.",
            metaTitle: "Dhol Players Dublin | Dhol Drummers Ireland | Imperial Drummers",
            metaDescription: "Book professional dhol players in Dublin for Asian weddings & events. Authentic Punjabi dhol entertainment across Dublin and Ireland."
          }
        ]
      },
      {
        slug: "belgium",
        name: "Belgium",
        description: "Professional dhol players for weddings and events in Belgium. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Brussels, Antwerp, and beyond.",
        metaTitle: "Dhol Players Belgium | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Belgium for Asian weddings & events. Authentic Punjabi dhol entertainment in Brussels, Antwerp & across Belgium.",
        majorCities: ["Antwerp", "Ghent", "Bruges", "Leuven", "Liege"],
        cities: [
          {
            slug: "brussels",
            name: "Brussels",
            description: "Professional dhol players for weddings and events in Brussels. Our drummers bring vibrant Punjabi entertainment to celebrations in the heart of Europe.",
            metaTitle: "Dhol Players Brussels | Dhol Drummers Belgium | Imperial Drummers",
            metaDescription: "Book professional dhol players in Brussels for Asian weddings & events. Authentic Punjabi dhol entertainment across Brussels and Belgium."
          }
        ]
      },
      {
        slug: "switzerland",
        name: "Switzerland",
        description: "Professional dhol players for luxury weddings and events in Switzerland. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Zurich, Geneva, and across the Swiss Alps.",
        metaTitle: "Dhol Players Switzerland | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Switzerland for luxury weddings & events. Authentic Punjabi dhol entertainment in Zurich, Geneva & across Switzerland.",
        majorCities: ["Geneva", "Basel", "Bern", "Lausanne", "Lucerne", "Interlaken", "St. Moritz"],
        cities: [
          {
            slug: "zurich",
            name: "Zurich",
            description: "Professional dhol players for weddings and events in Zurich. Our drummers bring authentic Punjabi energy to celebrations across Switzerland's largest city.",
            metaTitle: "Dhol Players Zurich | Dhol Drummers Switzerland | Imperial Drummers",
            metaDescription: "Book professional dhol players in Zurich for Asian weddings & events. Authentic Punjabi dhol entertainment across Zurich and Switzerland."
          }
        ]
      },
      {
        slug: "austria",
        name: "Austria",
        description: "Professional dhol players for weddings and events in Austria. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Vienna and across Austria.",
        metaTitle: "Dhol Players Austria | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Austria for Asian weddings & events. Authentic Punjabi dhol entertainment in Vienna and across Austria.",
        majorCities: ["Salzburg", "Innsbruck", "Graz", "Linz"],
        cities: [
          {
            slug: "vienna",
            name: "Vienna",
            description: "Professional dhol players for weddings and events in Vienna. Our drummers bring vibrant Punjabi entertainment to celebrations in Austria's elegant capital.",
            metaTitle: "Dhol Players Vienna | Dhol Drummers Austria | Imperial Drummers",
            metaDescription: "Book professional dhol players in Vienna for Asian weddings & events. Authentic Punjabi dhol entertainment across Vienna and Austria."
          }
        ]
      },
      {
        slug: "greece",
        name: "Greece",
        description: "Professional dhol players for destination weddings in Greece. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Athens, Santorini, and the Greek islands.",
        metaTitle: "Dhol Players Greece | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Greece for destination weddings & events. Authentic Punjabi dhol entertainment in Athens, Santorini & across Greece.",
        majorCities: ["Santorini", "Mykonos", "Thessaloniki", "Crete", "Rhodes", "Corfu", "Zakynthos"],
        cities: [
          {
            slug: "athens",
            name: "Athens",
            description: "Professional dhol players for weddings and events in Athens. Our drummers bring authentic Punjabi rhythms to celebrations in the historic Greek capital.",
            metaTitle: "Dhol Players Athens | Dhol Drummers Greece | Imperial Drummers",
            metaDescription: "Book professional dhol players in Athens for destination weddings & events. Authentic Punjabi dhol entertainment across Athens and Greece."
          }
        ]
      },
      {
        slug: "sweden",
        name: "Sweden",
        description: "Professional dhol players for weddings and events in Sweden. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Stockholm and across Scandinavia.",
        metaTitle: "Dhol Players Sweden | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Sweden for Asian weddings & events. Authentic Punjabi dhol entertainment in Stockholm and across Sweden.",
        majorCities: ["Stockholm", "Gothenburg", "Malmo", "Uppsala"],
        cities: []
      },
      {
        slug: "norway",
        name: "Norway",
        description: "Professional dhol players for weddings and events in Norway. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Oslo and across Norway.",
        metaTitle: "Dhol Players Norway | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Norway for Asian weddings & events. Authentic Punjabi dhol entertainment in Oslo and across Norway.",
        majorCities: ["Oslo", "Bergen", "Stavanger", "Trondheim"],
        cities: []
      },
      {
        slug: "portugal",
        name: "Portugal",
        description: "Professional dhol players for destination weddings in Portugal. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Lisbon, the Algarve, and across Portugal.",
        metaTitle: "Dhol Players Portugal | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Portugal for destination weddings & events. Authentic Punjabi dhol entertainment in Lisbon, Algarve & across Portugal.",
        majorCities: ["Porto", "Faro", "Algarve", "Sintra", "Madeira", "Cascais"],
        cities: [
          {
            slug: "lisbon",
            name: "Lisbon",
            description: "Professional dhol players for destination weddings and events in Lisbon. Our drummers bring authentic Punjabi energy to celebrations in Portugal's stunning capital.",
            metaTitle: "Dhol Players Lisbon | Dhol Drummers Portugal | Imperial Drummers",
            metaDescription: "Book professional dhol players in Lisbon for destination weddings & events. Authentic Punjabi dhol entertainment across Lisbon and Portugal."
          }
        ]
      }
    ]
  },
  {
    slug: "north-america",
    name: "North America",
    description: "Professional dhol players available across North America for weddings, corporate events, and cultural celebrations. Imperial Drummers brings authentic Punjabi dhol entertainment to the USA, Canada, and Mexico.",
    metaTitle: "Dhol Players North America | Professional Dhol Drummers USA & Canada | Imperial Drummers",
    metaDescription: "Book professional dhol players across North America. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in the USA, Canada & Mexico.",
    countries: [
      {
        slug: "united-states",
        name: "United States",
        description: "Professional dhol players available across the United States for weddings and cultural celebrations. Imperial Drummers serves the growing South Asian diaspora with authentic Punjabi dhol entertainment from coast to coast.",
        metaTitle: "Dhol Players USA | Professional Dhol Drummers United States | Imperial Drummers",
        metaDescription: "Book professional dhol players across the USA. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in New York, Los Angeles, Chicago, Houston & more.",
        majorCities: ["Boston", "Miami", "Seattle", "Denver", "Phoenix", "Philadelphia", "Detroit", "Minneapolis", "San Diego", "Austin", "Orlando", "Nashville", "Portland", "Las Vegas", "San Jose", "Raleigh", "Charlotte", "Tampa", "Indianapolis", "Columbus", "Sacramento", "St. Louis", "New Jersey", "Long Island"],
        cities: [
          {
            slug: "new-york",
            name: "New York",
            description: "Professional dhol players for weddings and events in New York City and the tri-state area. Our drummers bring authentic Punjabi energy to celebrations at Manhattan venues, Long Island estates, and New Jersey banquet halls.",
            metaTitle: "Dhol Players New York | Professional Dhol Drummers NYC | Imperial Drummers",
            metaDescription: "Book professional dhol players in New York for Asian weddings & events. Authentic Punjabi dhol entertainment across NYC, Long Island, New Jersey & the tri-state area."
          },
          {
            slug: "los-angeles",
            name: "Los Angeles",
            description: "Professional dhol players for weddings and events in Los Angeles. Our drummers bring vibrant Punjabi entertainment to celebrations across LA, Orange County, and Southern California.",
            metaTitle: "Dhol Players Los Angeles | Dhol Drummers LA | Imperial Drummers",
            metaDescription: "Book professional dhol players in Los Angeles for Asian weddings & events. Authentic Punjabi dhol entertainment across LA, Orange County & Southern California."
          },
          {
            slug: "chicago",
            name: "Chicago",
            description: "Professional dhol players for weddings and events in Chicago and the greater Midwest. Our experienced drummers serve the thriving South Asian community across Chicagoland and surrounding states.",
            metaTitle: "Dhol Players Chicago | Professional Dhol Drummers Illinois | Imperial Drummers",
            metaDescription: "Book professional dhol players in Chicago for Asian weddings & events. Authentic Punjabi dhol entertainment across Chicagoland and the Midwest."
          },
          {
            slug: "houston",
            name: "Houston",
            description: "Professional dhol players for weddings and events in Houston. Our drummers bring authentic Punjabi rhythms to the South Asian community's celebrations across the Greater Houston area and Texas.",
            metaTitle: "Dhol Players Houston | Dhol Drummers Texas | Imperial Drummers",
            metaDescription: "Book professional dhol players in Houston for Asian weddings & events. Authentic Punjabi dhol entertainment across Houston and Texas."
          },
          {
            slug: "san-francisco",
            name: "San Francisco",
            description: "Professional dhol players for weddings and events in San Francisco and the Bay Area. Our drummers bring vibrant Punjabi energy to celebrations across Silicon Valley, the Peninsula, and Northern California.",
            metaTitle: "Dhol Players San Francisco | Dhol Drummers Bay Area | Imperial Drummers",
            metaDescription: "Book professional dhol players in San Francisco for Asian weddings & events. Authentic Punjabi dhol entertainment across the Bay Area and Northern California."
          },
          {
            slug: "washington-dc",
            name: "Washington DC",
            description: "Professional dhol players for weddings and events in Washington DC, Virginia, and Maryland. Our drummers bring authentic Punjabi entertainment to celebrations across the DMV area.",
            metaTitle: "Dhol Players Washington DC | Dhol Drummers DMV | Imperial Drummers",
            metaDescription: "Book professional dhol players in Washington DC for Asian weddings & events. Authentic Punjabi dhol entertainment across DC, Virginia & Maryland."
          },
          {
            slug: "atlanta",
            name: "Atlanta",
            description: "Professional dhol players for weddings and events in Atlanta. Our drummers bring authentic Punjabi energy to the South Asian community's celebrations across metro Atlanta and Georgia.",
            metaTitle: "Dhol Players Atlanta | Dhol Drummers Georgia | Imperial Drummers",
            metaDescription: "Book professional dhol players in Atlanta for Asian weddings & events. Authentic Punjabi dhol entertainment across Atlanta and Georgia."
          },
          {
            slug: "dallas",
            name: "Dallas",
            description: "Professional dhol players for weddings and events in Dallas-Fort Worth. Our drummers bring vibrant Punjabi rhythms to celebrations across the DFW metroplex and North Texas.",
            metaTitle: "Dhol Players Dallas | Dhol Drummers DFW Texas | Imperial Drummers",
            metaDescription: "Book professional dhol players in Dallas for Asian weddings & events. Authentic Punjabi dhol entertainment across Dallas-Fort Worth and North Texas."
          }
        ]
      },
      {
        slug: "canada",
        name: "Canada",
        description: "Professional dhol players available across Canada for weddings and cultural celebrations. Imperial Drummers serves Canada's vibrant South Asian communities with authentic Punjabi dhol entertainment.",
        metaTitle: "Dhol Players Canada | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players across Canada. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in Toronto, Vancouver, Calgary & Montreal.",
        majorCities: ["Edmonton", "Ottawa", "Winnipeg", "Brampton", "Mississauga", "Surrey", "Hamilton", "Halifax", "Victoria", "Saskatoon", "Regina"],
        cities: [
          {
            slug: "toronto",
            name: "Toronto",
            description: "Professional dhol players for weddings and events in Toronto and the GTA. Our drummers bring authentic Punjabi energy to celebrations across the Greater Toronto Area, Brampton, Mississauga, and Ontario.",
            metaTitle: "Dhol Players Toronto | Dhol Drummers GTA Ontario | Imperial Drummers",
            metaDescription: "Book professional dhol players in Toronto for Asian weddings & events. Authentic Punjabi dhol entertainment across the GTA, Brampton, Mississauga & Ontario."
          },
          {
            slug: "vancouver",
            name: "Vancouver",
            description: "Professional dhol players for weddings and events in Vancouver and the Lower Mainland. Our drummers bring vibrant Punjabi entertainment to celebrations across Surrey, Burnaby, and British Columbia.",
            metaTitle: "Dhol Players Vancouver | Dhol Drummers BC | Imperial Drummers",
            metaDescription: "Book professional dhol players in Vancouver for Asian weddings & events. Authentic Punjabi dhol entertainment across Vancouver, Surrey & British Columbia."
          },
          {
            slug: "calgary",
            name: "Calgary",
            description: "Professional dhol players for weddings and events in Calgary. Our drummers bring authentic Punjabi rhythms to the South Asian community's celebrations across Calgary and Alberta.",
            metaTitle: "Dhol Players Calgary | Dhol Drummers Alberta | Imperial Drummers",
            metaDescription: "Book professional dhol players in Calgary for Asian weddings & events. Authentic Punjabi dhol entertainment across Calgary and Alberta."
          },
          {
            slug: "montreal",
            name: "Montreal",
            description: "Professional dhol players for weddings and events in Montreal. Our drummers bring vibrant Punjabi energy to celebrations across Montreal, Laval, and Quebec.",
            metaTitle: "Dhol Players Montreal | Dhol Drummers Quebec | Imperial Drummers",
            metaDescription: "Book professional dhol players in Montreal for Asian weddings & events. Authentic Punjabi dhol entertainment across Montreal and Quebec."
          }
        ]
      },
      {
        slug: "mexico",
        name: "Mexico",
        description: "Professional dhol players for destination weddings in Mexico. Imperial Drummers brings authentic Punjabi dhol entertainment to luxury celebrations in Cancun, Mexico City, and across Mexico.",
        metaTitle: "Dhol Players Mexico | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Mexico for destination weddings & events. Authentic Punjabi dhol entertainment in Cancun, Mexico City & across Mexico.",
        majorCities: ["Guadalajara", "Monterrey", "Playa del Carmen", "Tulum", "Los Cabos", "Puerto Vallarta"],
        cities: [
          {
            slug: "cancun",
            name: "Cancun",
            description: "Professional dhol players for destination weddings in Cancun and the Riviera Maya. Our drummers bring authentic Punjabi energy to luxury beachfront celebrations along Mexico's Caribbean coast.",
            metaTitle: "Dhol Players Cancun | Dhol Drummers Riviera Maya | Imperial Drummers",
            metaDescription: "Book professional dhol players in Cancun for destination weddings. Authentic Punjabi dhol entertainment at luxury Riviera Maya venues."
          },
          {
            slug: "mexico-city",
            name: "Mexico City",
            description: "Professional dhol players for weddings and events in Mexico City. Our drummers bring vibrant Punjabi rhythms to celebrations across CDMX.",
            metaTitle: "Dhol Players Mexico City | Dhol Drummers CDMX | Imperial Drummers",
            metaDescription: "Book professional dhol players in Mexico City for Asian weddings & events. Authentic Punjabi dhol entertainment across CDMX."
          }
        ]
      }
    ]
  },
  {
    slug: "asia",
    name: "Asia",
    description: "Professional dhol players available across Asia for weddings, corporate events, and cultural celebrations. Imperial Drummers brings authentic Punjabi dhol entertainment to venues throughout the continent, from India to the UAE and beyond.",
    metaTitle: "Dhol Players Asia | Professional Dhol Drummers India, UAE & More | Imperial Drummers",
    metaDescription: "Book professional dhol players across Asia. Imperial Drummers provides authentic Punjabi dhol entertainment for weddings & events in India, UAE, Singapore, Malaysia & more.",
    countries: [
      {
        slug: "india",
        name: "India",
        description: "Professional UK-based dhol players available for destination weddings across India. Imperial Drummers brings a premium British-Punjabi dhol experience to celebrations in Delhi, Mumbai, Jaipur, Chandigarh, and beyond.",
        metaTitle: "Dhol Players India | UK Dhol Drummers for Indian Weddings | Imperial Drummers",
        metaDescription: "Book premium UK-based dhol players for destination weddings in India. Imperial Drummers provides professional British-Punjabi dhol entertainment in Delhi, Mumbai, Jaipur, Chandigarh & more.",
        majorCities: ["Bangalore", "Hyderabad", "Chennai", "Kolkata", "Pune", "Ahmedabad", "Udaipur", "Lucknow", "Ludhiana", "Jalandhar", "Patiala", "Mohali", "Surat", "Indore", "Bhopal", "Kochi", "Nagpur", "Agra", "Jodhpur"],
        cities: [
          {
            slug: "delhi",
            name: "Delhi",
            description: "Premium UK-based dhol players for destination weddings in Delhi and NCR. Our British-trained drummers bring a unique fusion of traditional and modern dhol performance to celebrations across Delhi, Gurgaon, and Noida.",
            metaTitle: "Dhol Players Delhi | UK Dhol Drummers NCR | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for destination weddings in Delhi NCR. Professional British-Punjabi dhol entertainment across Delhi, Gurgaon & Noida."
          },
          {
            slug: "mumbai",
            name: "Mumbai",
            description: "Premium UK-based dhol players for destination weddings in Mumbai. Our British-trained drummers bring a unique international dhol experience to celebrations across Mumbai and Maharashtra.",
            metaTitle: "Dhol Players Mumbai | UK Dhol Drummers Maharashtra | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for destination weddings in Mumbai. Professional British-Punjabi dhol entertainment across Mumbai and Maharashtra."
          },
          {
            slug: "jaipur",
            name: "Jaipur",
            description: "Premium UK-based dhol players for destination weddings in Jaipur. Our drummers bring a world-class performance to celebrations at the Pink City's magnificent palaces and luxury heritage hotels.",
            metaTitle: "Dhol Players Jaipur | UK Dhol Drummers Rajasthan | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for destination weddings in Jaipur. Professional dhol entertainment at Rajasthan's palace venues and luxury hotels."
          },
          {
            slug: "chandigarh",
            name: "Chandigarh",
            description: "Premium UK-based dhol players for weddings in Chandigarh, the heart of Punjab. Our British-trained drummers bring an international quality performance to celebrations in the City Beautiful.",
            metaTitle: "Dhol Players Chandigarh | UK Dhol Drummers Punjab | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for weddings in Chandigarh. Professional British-Punjabi dhol entertainment in the City Beautiful and Punjab."
          },
          {
            slug: "amritsar",
            name: "Amritsar",
            description: "Premium UK-based dhol players for weddings in Amritsar. Our British-trained drummers bring an international touch to celebrations in the holy city of the Sikhs and across Punjab.",
            metaTitle: "Dhol Players Amritsar | UK Dhol Drummers Punjab | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for weddings in Amritsar. Professional British-Punjabi dhol entertainment in Amritsar and Punjab."
          },
          {
            slug: "goa",
            name: "Goa",
            description: "Premium UK-based dhol players for destination weddings in Goa. Our drummers bring high-energy Punjabi performance to beachfront celebrations and luxury resort weddings across Goa.",
            metaTitle: "Dhol Players Goa | UK Dhol Drummers for Beach Weddings | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for destination weddings in Goa. Professional dhol entertainment at Goa's beachfront venues and luxury resorts."
          }
        ]
      },
      {
        slug: "uae",
        name: "UAE",
        description: "Professional dhol players for weddings and events across the UAE. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Dubai, Abu Dhabi, and the Emirates.",
        metaTitle: "Dhol Players UAE | Professional Dhol Drummers Dubai & Abu Dhabi | Imperial Drummers",
        metaDescription: "Book professional dhol players in the UAE for Asian weddings & events. Authentic Punjabi dhol entertainment in Dubai, Abu Dhabi & across the Emirates.",
        majorCities: ["Sharjah", "Ajman", "Ras Al Khaimah", "Fujairah"],
        cities: [
          {
            slug: "dubai",
            name: "Dubai",
            description: "Professional dhol players for weddings and events in Dubai. Our drummers bring authentic Punjabi energy to celebrations at luxury venues, beach clubs, and grand ballrooms across Dubai.",
            metaTitle: "Dhol Players Dubai | Professional Dhol Drummers UAE | Imperial Drummers",
            metaDescription: "Book professional dhol players in Dubai for Asian weddings & events. Authentic Punjabi dhol entertainment at luxury Dubai venues and ballrooms."
          },
          {
            slug: "abu-dhabi",
            name: "Abu Dhabi",
            description: "Professional dhol players for weddings and events in Abu Dhabi. Our drummers bring vibrant Punjabi entertainment to celebrations across the UAE capital.",
            metaTitle: "Dhol Players Abu Dhabi | Dhol Drummers UAE | Imperial Drummers",
            metaDescription: "Book professional dhol players in Abu Dhabi for Asian weddings & events. Authentic Punjabi dhol entertainment across Abu Dhabi and the UAE."
          }
        ]
      },
      {
        slug: "singapore",
        name: "Singapore",
        description: "Professional dhol players for weddings and events in Singapore. Imperial Drummers brings authentic Punjabi dhol entertainment to the city-state's vibrant South Asian community.",
        metaTitle: "Dhol Players Singapore | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Singapore for Asian weddings & events. Authentic Punjabi dhol entertainment across Singapore.",
        majorCities: ["Orchard", "Marina Bay", "Sentosa", "Jurong", "Changi"],
        cities: []
      },
      {
        slug: "philippines",
        name: "Philippines",
        description: "Professional dhol players for destination weddings in the Philippines. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Manila, Boracay, and across the islands.",
        metaTitle: "Dhol Players Philippines | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in the Philippines for destination weddings & events. Authentic Punjabi dhol entertainment in Manila & across the Philippines.",
        majorCities: ["Manila", "Cebu", "Boracay", "Davao", "Palawan"],
        cities: []
      },
      {
        slug: "malaysia",
        name: "Malaysia",
        description: "Professional dhol players for weddings and events in Malaysia. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Kuala Lumpur and across Malaysia.",
        metaTitle: "Dhol Players Malaysia | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Malaysia for Asian weddings & events. Authentic Punjabi dhol entertainment in Kuala Lumpur & across Malaysia.",
        majorCities: ["Penang", "Johor Bahru", "Ipoh", "Kota Kinabalu", "Langkawi"],
        cities: [
          {
            slug: "kuala-lumpur",
            name: "Kuala Lumpur",
            description: "Professional dhol players for weddings and events in Kuala Lumpur. Our drummers bring authentic Punjabi rhythms to celebrations across KL and the Klang Valley.",
            metaTitle: "Dhol Players Kuala Lumpur | Dhol Drummers Malaysia | Imperial Drummers",
            metaDescription: "Book professional dhol players in Kuala Lumpur for Asian weddings & events. Authentic Punjabi dhol entertainment across KL and Malaysia."
          }
        ]
      },
      {
        slug: "thailand",
        name: "Thailand",
        description: "Professional dhol players for destination weddings in Thailand. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Bangkok, Phuket, and across Thailand.",
        metaTitle: "Dhol Players Thailand | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Thailand for destination weddings & events. Authentic Punjabi dhol entertainment in Bangkok, Phuket & across Thailand.",
        majorCities: ["Phuket", "Chiang Mai", "Pattaya", "Koh Samui", "Krabi", "Hua Hin"],
        cities: [
          {
            slug: "bangkok",
            name: "Bangkok",
            description: "Professional dhol players for destination weddings and events in Bangkok. Our drummers bring vibrant Punjabi energy to celebrations across Thailand's capital city.",
            metaTitle: "Dhol Players Bangkok | Dhol Drummers Thailand | Imperial Drummers",
            metaDescription: "Book professional dhol players in Bangkok for destination weddings & events. Authentic Punjabi dhol entertainment across Bangkok and Thailand."
          }
        ]
      },
      {
        slug: "japan",
        name: "Japan",
        description: "Professional dhol players for weddings and events in Japan. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Tokyo and across Japan.",
        metaTitle: "Dhol Players Japan | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Japan for Asian weddings & events. Authentic Punjabi dhol entertainment in Tokyo and across Japan.",
        majorCities: ["Osaka", "Kyoto", "Yokohama", "Kobe", "Nagoya", "Fukuoka"],
        cities: [
          {
            slug: "tokyo",
            name: "Tokyo",
            description: "Professional dhol players for weddings and events in Tokyo. Our drummers bring authentic Punjabi energy to celebrations in Japan's dynamic capital.",
            metaTitle: "Dhol Players Tokyo | Dhol Drummers Japan | Imperial Drummers",
            metaDescription: "Book professional dhol players in Tokyo for Asian weddings & events. Authentic Punjabi dhol entertainment across Tokyo and Japan."
          }
        ]
      },
      {
        slug: "pakistan",
        name: "Pakistan",
        description: "Professional UK-based dhol players available for weddings in Pakistan. Imperial Drummers brings a premium British-Punjabi dhol experience to celebrations in Lahore, Islamabad, and Karachi.",
        metaTitle: "Dhol Players Pakistan | UK Dhol Drummers | Imperial Drummers",
        metaDescription: "Book premium UK-based dhol players for weddings in Pakistan. Professional British-Punjabi dhol entertainment in Lahore, Islamabad & Karachi.",
        majorCities: ["Karachi", "Rawalpindi", "Faisalabad", "Multan", "Peshawar", "Sialkot", "Gujranwala"],
        cities: [
          {
            slug: "lahore",
            name: "Lahore",
            description: "Premium UK-based dhol players for weddings in Lahore. Our British-trained drummers bring an international quality performance to celebrations in the cultural heart of Punjab.",
            metaTitle: "Dhol Players Lahore | UK Dhol Drummers Punjab | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for weddings in Lahore. Professional British-Punjabi dhol entertainment in Lahore, Punjab."
          },
          {
            slug: "islamabad",
            name: "Islamabad",
            description: "Premium UK-based dhol players for weddings in Islamabad. Our drummers bring a world-class performance to celebrations in Pakistan's capital city.",
            metaTitle: "Dhol Players Islamabad | UK Dhol Drummers Pakistan | Imperial Drummers",
            metaDescription: "Book premium UK-based dhol players for weddings in Islamabad. Professional British-Punjabi dhol entertainment in Pakistan's capital."
          }
        ]
      },
      {
        slug: "sri-lanka",
        name: "Sri Lanka",
        description: "Professional dhol players for destination weddings in Sri Lanka. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Colombo and across the island.",
        metaTitle: "Dhol Players Sri Lanka | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Sri Lanka for destination weddings & events. Authentic Punjabi dhol entertainment in Colombo & across Sri Lanka.",
        majorCities: ["Kandy", "Galle", "Negombo", "Bentota"],
        cities: [
          {
            slug: "colombo",
            name: "Colombo",
            description: "Professional dhol players for weddings and events in Colombo. Our drummers bring vibrant Punjabi energy to celebrations in Sri Lanka's capital.",
            metaTitle: "Dhol Players Colombo | Dhol Drummers Sri Lanka | Imperial Drummers",
            metaDescription: "Book professional dhol players in Colombo for Asian weddings & events. Authentic Punjabi dhol entertainment across Colombo and Sri Lanka."
          }
        ]
      }
    ]
  },
  {
    slug: "africa",
    name: "Africa",
    description: "Professional dhol players available across Africa for weddings and cultural celebrations. Imperial Drummers brings authentic Punjabi dhol entertainment to the South Asian diaspora communities throughout the continent.",
    metaTitle: "Dhol Players Africa | Professional Dhol Drummers | Imperial Drummers",
    metaDescription: "Book professional dhol players across Africa. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in South Africa, Kenya, Nigeria & more.",
    countries: [
      {
        slug: "south-africa",
        name: "South Africa",
        description: "Professional dhol players for weddings and events in South Africa. Imperial Drummers serves the South Asian community with authentic Punjabi dhol entertainment in Johannesburg, Durban, Cape Town, and beyond.",
        metaTitle: "Dhol Players South Africa | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in South Africa for Asian weddings & events. Authentic Punjabi dhol entertainment in Johannesburg, Durban, Cape Town & beyond.",
        majorCities: ["Pretoria", "Port Elizabeth", "Bloemfontein", "East London", "Pietermaritzburg", "Stellenbosch", "Sandton"],
        cities: [
          {
            slug: "johannesburg",
            name: "Johannesburg",
            description: "Professional dhol players for weddings and events in Johannesburg. Our drummers bring authentic Punjabi energy to celebrations across Joburg and Gauteng province.",
            metaTitle: "Dhol Players Johannesburg | Dhol Drummers South Africa | Imperial Drummers",
            metaDescription: "Book professional dhol players in Johannesburg for Asian weddings & events. Authentic Punjabi dhol entertainment across Joburg and Gauteng."
          },
          {
            slug: "durban",
            name: "Durban",
            description: "Professional dhol players for weddings and events in Durban. Our drummers bring vibrant Punjabi entertainment to the South Asian community's celebrations across KwaZulu-Natal.",
            metaTitle: "Dhol Players Durban | Dhol Drummers KwaZulu-Natal | Imperial Drummers",
            metaDescription: "Book professional dhol players in Durban for Asian weddings & events. Authentic Punjabi dhol entertainment across Durban and KwaZulu-Natal."
          },
          {
            slug: "cape-town",
            name: "Cape Town",
            description: "Professional dhol players for weddings and events in Cape Town. Our drummers bring authentic Punjabi rhythms to celebrations in the Mother City and Western Cape.",
            metaTitle: "Dhol Players Cape Town | Dhol Drummers Western Cape | Imperial Drummers",
            metaDescription: "Book professional dhol players in Cape Town for Asian weddings & events. Authentic Punjabi dhol entertainment across Cape Town and the Western Cape."
          }
        ]
      },
      {
        slug: "kenya",
        name: "Kenya",
        description: "Professional dhol players for weddings and events in Kenya. Imperial Drummers brings authentic Punjabi dhol entertainment to the South Asian community's celebrations in Nairobi and Mombasa.",
        metaTitle: "Dhol Players Kenya | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Kenya for Asian weddings & events. Authentic Punjabi dhol entertainment in Nairobi, Mombasa & across Kenya.",
        majorCities: ["Mombasa", "Kisumu", "Nakuru", "Malindi"],
        cities: [
          {
            slug: "nairobi",
            name: "Nairobi",
            description: "Professional dhol players for weddings and events in Nairobi. Our drummers bring authentic Punjabi energy to celebrations across Kenya's capital.",
            metaTitle: "Dhol Players Nairobi | Dhol Drummers Kenya | Imperial Drummers",
            metaDescription: "Book professional dhol players in Nairobi for Asian weddings & events. Authentic Punjabi dhol entertainment across Nairobi and Kenya."
          }
        ]
      },
      {
        slug: "nigeria",
        name: "Nigeria",
        description: "Professional dhol players for weddings and events in Nigeria. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Lagos, Abuja, and across Nigeria.",
        metaTitle: "Dhol Players Nigeria | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Nigeria for Asian weddings & events. Authentic Punjabi dhol entertainment in Lagos, Abuja & across Nigeria.",
        majorCities: ["Abuja", "Port Harcourt", "Kano", "Ibadan"],
        cities: [
          {
            slug: "lagos",
            name: "Lagos",
            description: "Professional dhol players for weddings and events in Lagos. Our drummers bring vibrant Punjabi entertainment to celebrations across Nigeria's largest city.",
            metaTitle: "Dhol Players Lagos | Dhol Drummers Nigeria | Imperial Drummers",
            metaDescription: "Book professional dhol players in Lagos for Asian weddings & events. Authentic Punjabi dhol entertainment across Lagos and Nigeria."
          }
        ]
      },
      {
        slug: "morocco",
        name: "Morocco",
        description: "Professional dhol players for destination weddings in Morocco. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Marrakech and across Morocco.",
        metaTitle: "Dhol Players Morocco | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Morocco for destination weddings & events. Authentic Punjabi dhol entertainment in Marrakech & across Morocco.",
        majorCities: ["Casablanca", "Fez", "Rabat", "Tangier", "Agadir"],
        cities: [
          {
            slug: "marrakech",
            name: "Marrakech",
            description: "Professional dhol players for destination weddings in Marrakech. Our drummers bring authentic Punjabi energy to luxury celebrations at riads and palaces across the Red City.",
            metaTitle: "Dhol Players Marrakech | Dhol Drummers Morocco | Imperial Drummers",
            metaDescription: "Book professional dhol players in Marrakech for destination weddings. Authentic Punjabi dhol entertainment at luxury Marrakech venues."
          }
        ]
      },
      {
        slug: "egypt",
        name: "Egypt",
        description: "Professional dhol players for destination weddings in Egypt. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Cairo and across Egypt.",
        metaTitle: "Dhol Players Egypt | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Egypt for destination weddings & events. Authentic Punjabi dhol entertainment in Cairo & across Egypt.",
        majorCities: ["Cairo", "Alexandria", "Luxor", "Sharm El Sheikh", "Hurghada"],
        cities: []
      }
    ]
  },
  {
    slug: "south-america",
    name: "South America",
    description: "Professional dhol players available for destination weddings and events across South America. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Brazil, Argentina, and Colombia.",
    metaTitle: "Dhol Players South America | Professional Dhol Drummers | Imperial Drummers",
    metaDescription: "Book professional dhol players across South America. Imperial Drummers provides authentic Punjabi dhol entertainment for destination weddings & events in Brazil, Argentina & Colombia.",
    countries: [
      {
        slug: "brazil",
        name: "Brazil",
        description: "Professional dhol players for destination weddings in Brazil. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Rio de Janeiro, Sao Paulo, and across Brazil.",
        metaTitle: "Dhol Players Brazil | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Brazil for destination weddings & events. Authentic Punjabi dhol entertainment in Rio de Janeiro, Sao Paulo & across Brazil.",
        majorCities: ["Sao Paulo", "Brasilia", "Salvador", "Fortaleza", "Belo Horizonte", "Recife"],
        cities: [
          {
            slug: "rio-de-janeiro",
            name: "Rio de Janeiro",
            description: "Professional dhol players for destination weddings in Rio de Janeiro. Our drummers bring vibrant Punjabi energy to celebrations across the Cidade Maravilhosa.",
            metaTitle: "Dhol Players Rio de Janeiro | Dhol Drummers Brazil | Imperial Drummers",
            metaDescription: "Book professional dhol players in Rio de Janeiro for destination weddings. Authentic Punjabi dhol entertainment across Rio and Brazil."
          }
        ]
      },
      {
        slug: "argentina",
        name: "Argentina",
        description: "Professional dhol players for destination weddings in Argentina. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Buenos Aires and across Argentina.",
        metaTitle: "Dhol Players Argentina | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Argentina for destination weddings & events. Authentic Punjabi dhol entertainment in Buenos Aires & across Argentina.",
        majorCities: ["Buenos Aires", "Mendoza", "Cordoba", "Rosario", "Bariloche"],
        cities: []
      },
      {
        slug: "colombia",
        name: "Colombia",
        description: "Professional dhol players for destination weddings in Colombia. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Cartagena, Bogota, and across Colombia.",
        metaTitle: "Dhol Players Colombia | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Colombia for destination weddings & events. Authentic Punjabi dhol entertainment in Cartagena, Bogota & across Colombia.",
        majorCities: ["Bogota", "Cartagena", "Medellin", "Cali", "Barranquilla"],
        cities: []
      }
    ]
  },
  {
    slug: "oceania",
    name: "Oceania",
    description: "Professional dhol players available across Oceania for weddings and cultural celebrations. Imperial Drummers brings authentic Punjabi dhol entertainment to Australia, New Zealand, and the Pacific Islands.",
    metaTitle: "Dhol Players Oceania | Professional Dhol Drummers Australia & NZ | Imperial Drummers",
    metaDescription: "Book professional dhol players across Oceania. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in Australia, New Zealand & Fiji.",
    countries: [
      {
        slug: "australia",
        name: "Australia",
        description: "Professional dhol players for weddings and events across Australia. Imperial Drummers serves Australia's vibrant South Asian community with authentic Punjabi dhol entertainment in Sydney, Melbourne, Brisbane, Perth, and beyond.",
        metaTitle: "Dhol Players Australia | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players across Australia. Imperial Drummers provides authentic Punjabi dhol entertainment for Asian weddings & events in Sydney, Melbourne, Brisbane & Perth.",
        majorCities: ["Adelaide", "Gold Coast", "Canberra", "Newcastle", "Hobart", "Darwin", "Parramatta", "Geelong"],
        cities: [
          {
            slug: "sydney",
            name: "Sydney",
            description: "Professional dhol players for weddings and events in Sydney. Our drummers bring authentic Punjabi energy to celebrations across Sydney, Parramatta, and greater New South Wales.",
            metaTitle: "Dhol Players Sydney | Dhol Drummers NSW | Imperial Drummers",
            metaDescription: "Book professional dhol players in Sydney for Asian weddings & events. Authentic Punjabi dhol entertainment across Sydney and New South Wales."
          },
          {
            slug: "melbourne",
            name: "Melbourne",
            description: "Professional dhol players for weddings and events in Melbourne. Our drummers bring vibrant Punjabi entertainment to celebrations across Melbourne and Victoria.",
            metaTitle: "Dhol Players Melbourne | Dhol Drummers Victoria | Imperial Drummers",
            metaDescription: "Book professional dhol players in Melbourne for Asian weddings & events. Authentic Punjabi dhol entertainment across Melbourne and Victoria."
          },
          {
            slug: "brisbane",
            name: "Brisbane",
            description: "Professional dhol players for weddings and events in Brisbane. Our drummers bring authentic Punjabi rhythms to celebrations across Brisbane and Queensland.",
            metaTitle: "Dhol Players Brisbane | Dhol Drummers Queensland | Imperial Drummers",
            metaDescription: "Book professional dhol players in Brisbane for Asian weddings & events. Authentic Punjabi dhol entertainment across Brisbane and Queensland."
          },
          {
            slug: "perth",
            name: "Perth",
            description: "Professional dhol players for weddings and events in Perth. Our drummers bring vibrant Punjabi energy to celebrations across Perth and Western Australia.",
            metaTitle: "Dhol Players Perth | Dhol Drummers Western Australia | Imperial Drummers",
            metaDescription: "Book professional dhol players in Perth for Asian weddings & events. Authentic Punjabi dhol entertainment across Perth and Western Australia."
          }
        ]
      },
      {
        slug: "new-zealand",
        name: "New Zealand",
        description: "Professional dhol players for weddings and events in New Zealand. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations in Auckland, Wellington, and across Aotearoa.",
        metaTitle: "Dhol Players New Zealand | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in New Zealand for Asian weddings & events. Authentic Punjabi dhol entertainment in Auckland, Wellington & across NZ.",
        majorCities: ["Wellington", "Christchurch", "Hamilton", "Tauranga", "Queenstown"],
        cities: [
          {
            slug: "auckland",
            name: "Auckland",
            description: "Professional dhol players for weddings and events in Auckland. Our drummers bring authentic Punjabi energy to celebrations across Auckland and the greater North Island.",
            metaTitle: "Dhol Players Auckland | Dhol Drummers New Zealand | Imperial Drummers",
            metaDescription: "Book professional dhol players in Auckland for Asian weddings & events. Authentic Punjabi dhol entertainment across Auckland and New Zealand."
          }
        ]
      },
      {
        slug: "fiji",
        name: "Fiji",
        description: "Professional dhol players for destination weddings in Fiji. Imperial Drummers brings authentic Punjabi dhol entertainment to celebrations across the beautiful Fijian islands.",
        metaTitle: "Dhol Players Fiji | Professional Dhol Drummers | Imperial Drummers",
        metaDescription: "Book professional dhol players in Fiji for destination weddings. Authentic Punjabi dhol entertainment across the Fijian islands.",
        majorCities: ["Suva", "Nadi", "Denarau Island", "Coral Coast"],
        cities: []
      }
    ]
  }
];

// Build lookup maps
const continentBySlug = {};
const countryLookup = {}; // { countrySlug: { country, continent } }
const cityLookup = {};    // { citySlug: { city, country, continent } } (international cities only)

continents.forEach(continent => {
  continentBySlug[continent.slug] = continent;
  continent.countries.forEach(country => {
    countryLookup[`${continent.slug}/${country.slug}`] = { country, continent };
    if (!country.useLegacyCities) {
      country.cities.forEach(city => {
        cityLookup[`${continent.slug}/${country.slug}/${city.slug}`] = { city, country, continent };
      });
    }
  });
});

// Set of continent slugs for the LocationRouter
const continentSlugs = new Set(continents.map(c => c.slug));

// Public API
export const getContinentBySlug = (slug) => continentBySlug[slug] || null;

export const getCountry = (continentSlug, countrySlug) => {
  const entry = countryLookup[`${continentSlug}/${countrySlug}`];
  return entry || null;
};

export const getInternationalCity = (continentSlug, countrySlug, citySlug) => {
  const entry = cityLookup[`${continentSlug}/${countrySlug}/${citySlug}`];
  return entry || null;
};

export const isContinentSlug = (slug) => continentSlugs.has(slug);

export const getAllContinents = () => continents;

// Generate all paths for sitemap and react-snap
export const getAllInternationalPaths = () => {
  const paths = [];
  continents.forEach(continent => {
    paths.push(`/dhol-players/${continent.slug}`);
    continent.countries.forEach(country => {
      paths.push(`/dhol-players/${continent.slug}/${country.slug}`);
      if (!country.useLegacyCities) {
        country.cities.forEach(city => {
          paths.push(`/dhol-players/${continent.slug}/${country.slug}/${city.slug}`);
        });
      }
    });
  });
  return paths;
};
